module.exports = "table tr td:last-child,table tr th:last-child{text-align:center;width:100px}"